import { render, staticRenderFns } from "./backoffice-surgery-solicitation-details.vue?vue&type=template&id=4478b2d5"
import script from "./backoffice-surgery-solicitation-details.vue?vue&type=script&lang=ts"
export * from "./backoffice-surgery-solicitation-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports